var _rect, _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcColoredCash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F6F7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.448 21.1335C14.934 21.9767 13.6857 23.0381 7.15463 21.79C7.15463 16.4208 7.15182 16.1628 7.15323 10.7948C14.08 12.1584 15.36 8.63836 23.5492 10.1371C23.5492 12.4293 23.6116 11.539 23.5492 12.7983",
    stroke: "#20242E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3861 12.7926C21.759 12.7926 20.44 11.5616 20.44 10.043",
    stroke: "#20242E",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0638 10.8708C11.2178 12.4581 10.0921 13.8615 8.54946 14.0053C8.15221 14.0423 7.76605 13.9922 7.40898 13.8702",
    stroke: "#20242E",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15269 18.5684C8.77976 18.5684 10.0988 19.7995 10.0988 21.3181C10.0988 21.7092 10.0113 22.0812 9.85362 22.418",
    stroke: "#20242E",
    strokeWidth: 1.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.36,
    cy: 15.9981,
    r: 1.92,
    fill: "#20242E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4405 22.4696L19.3732 20.5843L21.2961 20.5249",
    stroke: "#20242E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2622 15.2623L26.3511 17.1467L24.4289 17.2281",
    stroke: "#20242E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0871 21.1375C20.8814 22.1362 22.1973 22.6837 23.5552 22.4505C25.1836 22.171 26.3588 20.8572 26.5046 19.3179",
    stroke: "#20242E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6312 16.6022C24.8256 15.6127 23.5035 15.0803 22.1483 15.329C20.5232 15.6271 19.3631 16.9543 19.2349 18.4951",
    stroke: "#20242E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcColoredCash);
export default __webpack_public_path__ + "static/media/ic-colored-cash.5c0fdea631f3ce32fec3ff282c18abe5.svg";
export { ForwardRef as ReactComponent };